import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./footer.css";
import FacebookIcon from '@mui/icons-material/Facebook';
import YouTubeIcon from '@mui/icons-material/YouTube';
import InstagramIcon from '@mui/icons-material/Instagram';
import LogoFooter from "../../assets/images/logo.jpg";
import GooglePlay from "../../assets/images/google-play.jpg";
import AppleStore from "../../assets/images/app-store.jpg";
import QRcode from "../../assets/images/qr_code.png";
import PaymentIcons from "../../assets/images/payment_icons.webp";
// import CADetailsImg from "../../assets/images/ca_detials.jpeg";

const Footer = () => {
  const [showScrollButton, setShowScrollButton] = useState(false);

  // Show button after scroll
  useEffect(() => {
    const handleScroll = () => {
      setShowScrollButton(window.scrollY > 100);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };

  return (
    <>
     

      <footer className="footer">
        <div className="container-fluid">
          <div className="row">

            <div className="col-lg-4 col-md-4 col-sm-6 col-12">
              <div className="footer-section footer-intro">
                <img src={LogoFooter} alt="Logo" className="footer_logo rounded" />
                <div className="footer-contact">
                  <span className="common_color">KTMEDU Mark Shopping Centre LLP</span>
                </div>
                <div className="footer-contact">
                  <span className="common_color">Offline Stores:</span> Dwarka Sector 15 South West Delhi, 110078 India
                </div>
                <div className="footer-contact">
                  <span className="common_color">Offline Stores:</span> Khair, Palwal Aligarsh Road Uttar Pradesh 201038
                </div>
                <div className="footer-contact">
                  <span className="common_color">Factory:</span> Khair, Palwal Aligarsh Road Uttar Pradesh 201038
                </div>
                <div className="footer-contact">
                  <span>Customer care <Link to="mailto:ktmedumarkservices@gmail.com">ktmedumarkservices@gmail.com</Link></span>
                </div>
              </div>
            </div>

            <div className="col-lg-2 col-md-2 col-sm-4 col-6">
              <div className="footer-section">
                <h4>Customer Support</h4>
                <ul>
                  <li><Link to="/contactus">Contact Us</Link></li>
                  <li><Link to="/aboutus">About Us</Link></li>
                  <li><Link to="/privacypolicy">Privacy Policy</Link></li>
                  
                </ul>
              </div>
            </div>

            <div className="col-lg-2 col-md-2 col-sm-4 col-6">
              <div className="footer-section">
                <h4>Quick Link</h4>
                <ul>
                  <li><Link to="/return">Cancellation & Returns</Link></li>
                  <li><Link to="/productslisting">Products</Link></li>
                  <li><Link to="/cart">My Cart</Link></li> 
                </ul>
                <div className="social_media mt_30">
                  <Link to="https://www.facebook.com/people/Ktmedu-Mark-Shopping-Centre/100090615271720/?mibextid=ZbWKwL" target="_blank"><FacebookIcon /></Link>
                  <Link to="https://www.youtube.com/@fmbgk" target="_blank" className="youtube"><YouTubeIcon /></Link>
                  <Link to="https://www.instagram.com/ktmedu_mark_shopping_center/?igsh=MWt2ZmY1dXB4aWNrYQ%3D%3D#" target="_blank"><InstagramIcon /></Link>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-4 col-sm-4 col-6">
              <div className="footer-section footer-app">
                <h4>Shop on The Go</h4>
                <p title="Design and Developed by Jogendra Rajput">Market Pro App is available. Get it now</p>
                <div className="app-buttons d_flex align_center gap_10">
                  <div className="qr_code">
                    <img src={QRcode} alt="QR Code" className="rounded" />
                  </div>
                  <div>
                    <Link to="https://play.google.com/store/apps/details?id=com.ktmedu_mark&pcampaignid=web_share" target="_blank" className="app-button"><img src={GooglePlay} alt="Google Play" className="rounded" /></Link>
                    <Link to="https://play.google.com/store/apps/details?id=com.ktmedu_mark&pcampaignid=web_share" target="_blank" className="app-button"><img src={AppleStore} alt="Apple Store" className="rounded" /></Link>
                  </div>
                </div>
                <div className="payment_icons">
                  <Link to=""><img src={PaymentIcons} alt="Payments" className="img-fluid" /></Link>
                </div>
              </div>
            </div>

          </div>
        </div>
      </footer>
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">
            <div className="position_relative">
                 {/* Scroll to Top Button */}
                  {showScrollButton && (
                    <div onClick={scrollToTop} id="scrollToTopBtn" className="cursor_pointer Jogendra Singh BSR" title="Go To Top">
                     <span></span>
                    </div>
                  )}
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid copy_write_bg">
        <div className="row">
          <div className="col-md-12">
            <div className="copy_write">
              <p className="text_center">&copy; all rights & reserved <span className="common_color">KTMEDU Mark Shopping Centre LLP</span></p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
